import type { ManagePaymentsLokiErrorType } from './error-types';
import { stringifyUnknownError } from './flatten-loki-fields';
import { type LokiFields, postLokiRecord } from './loki-transport';

/**
 * Sends a non-blocking error record to the Loki / Kafka REST proxy.
 * Swallows failures so logging never affects UX.
 */
export function logManagePaymentsLokiError(
	errorType: ManagePaymentsLokiErrorType,
	fields?: LokiFields,
	extraValues?: LokiFields,
): void {
	postLokiRecord('error', errorType, fields, extraValues);
}

export function logManagePaymentsLokiErrorFromUnknown(
	errorType: ManagePaymentsLokiErrorType,
	err: unknown,
	extra?: Record<string, string | number | boolean | null | undefined>,
): void {
	logManagePaymentsLokiError(errorType, {
		detail: stringifyUnknownError(err),
		...extra,
	});
}
